import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getFrasesRespuestaService,
  getFraseRespuestaByIdService,
  updateFraseRespuestaService,
} from "../../../services/talentos/talentos.service";

export const getFrasesRespuestaThunk = createAsyncThunk(
  "frasesRespuesta/getAll",
  async ({ page, search }, { rejectWithValue }) => {
    try {
      const data = await getFrasesRespuestaService(page, search);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al cargar las frases respuesta"
      );
    }
  }
);

export const getFraseRespuestaByIdThunk = createAsyncThunk(
  "frasesRespuesta/getById",
  async (id, { rejectWithValue }) => {
    try {
      const data = await getFraseRespuestaByIdService(id);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al cargar la frase respuesta"
      );
    }
  }
);

export const updateFraseRespuestaThunk = createAsyncThunk(
  "frasesRespuesta/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const data = await updateFraseRespuestaService(id, payload);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al actualizar la frase respuesta"
      );
    }
  }
);
